<template>
  <div class="pages">
    <div class="loadding" v-if="!page_show">
      <van-loading color="#00428e" type="spinner" size="48" />
    </div>
    <div v-else>
      <img class="top_img" :src="Util.getImgUrl(images.top)" />
      <img class="logo_img2" :src="Util.getImgUrl(images.logo)" />
      <img class="left_img" :src="Util.getImgUrl(images.left)" />
      <img class="right_img" :src="Util.getImgUrl(images.right)" />
      <img class="type_img" :src="Util.getImgUrl(images.type)" />
      <img class="nav_icon_img" :src="Util.getImgUrl(images.nav_icon)" @click="nav_show = true" />
      <div class="search_box">
        <van-popover v-model="showPopover" placement="bottom-start" trigger="click" theme="dark" :actions="areas"
          @select="onAreaChange">
          <template #reference>
            <!-- <van-button type="primary">浅色风格</van-button> -->
            <div class="location_box">
              <img class="location_img" :src="Util.getImgUrl(images.location)" />
              <div class="location_text">{{ area_title }}</div>
            </div>
          </template>
        </van-popover>


        <input class="search_text" placeholder="请输入搜索关键词" v-model="keywords" />
        <div class="search_btn" @click="onSearch">
          <img class="search_img" :src="Util.getImgUrl(images.search)" />
        </div>
      </div>
      <div class="content_box">
        <div v-if="list.length">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadData">
              <div class="employ_box" v-for="item in list" :key="item.position_id"
                @click="onClickDetail(item.position_id)">
                <div class="employ_top_box" :style="{ backgroundImage: 'url(' + Util.getImgUrl(images.spec) + ')' }">
                  <div class="position_name">{{ item.position_name }}</div>
                </div>
                <div class="label_list">
                  <div class="label">{{ item.area }}</div>
                  <div class="label">{{ item.position_type }}</div>
                  <div class="label">{{ item.people_num_text }}</div>
                </div>
                <div class="publish_box">{{ item.publish_at }}</div>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
        <div v-else-if="list.length <= 0 && page_show">
          <van-empty :image="Util.getImgUrl(empty_msg.image)"
            :description="empty_msg && empty_msg.title ? empty_msg.title : '暂无数据'" />
        </div>
      </div>
      <van-popup v-model="popup_show" round position="bottom" :close-on-click-overlay="false"
        :style="{ height: '80%', backgroundColor: 'transparent' }">
        <div class="detail_box" :style="{ backgroundImage: 'url(' + Util.getImgUrl(images.popup_bg) + ')' }"
          v-if="detail">
          <img class="popup_close" :src="Util.getImgUrl(images.popup_close)" @click="popup_show = false" />
          <div class="detail_header">
            <img class="popup_header" :src="Util.getImgUrl(images.popup_header)" />
            <div class="popup_position_name">
              <img :src="Util.getImgUrl(images.left_circle)" />
              <span>{{ detail.position_name }}</span>
              <img :src="Util.getImgUrl(images.right_circle)" />
            </div>
            <div class="popup_label_list">
              <van-icon :name="Util.getImgUrl(images.local)" size="14px" />
              <span>{{ detail.area }}</span>
              <van-icon :name="Util.getImgUrl(images.category)" size="14px" />
              <span>{{ detail.position_type }}</span>
              <van-icon :name="Util.getImgUrl(images.people_number)" size="14px" />
              <span>{{ detail.people_num_text }}</span>
            </div>
            <div class="popup_publish_at">{{ detail.publish_at }}发布</div>
          </div>
          <div class="detail_center">
            <div class="center_title">工作职责</div>
            <div class="center_content">
              <p class="content_textarea">{{ detail.responsibility }}</p>
            </div>
            <div class="center_title">
              <div class="left_tip"></div>
              <div>任职资格</div>
            </div>
            <div class="center_content">
              <p class="content_textarea">{{ detail.qualification }}</p>
            </div>
          </div>
          <div class="height_block"></div>
          <div class="detail_footer">
            <img class="popup_submit" :src="Util.getImgUrl(images.popup_submit)" />
            <span @click="$router.push({ name: post_router.name, query: post_router.args })">立即申请</span>
          </div>
        </div>
      </van-popup>

      <employNav :nav_show.sync="nav_show"></employNav>
    </div>
  </div>
</template>
<script>
import employNav from '../../components/employNav.vue'

export default {
  components: {
    employNav,
  },
  data() {
    return {
      page_show: false,
      popup_show: false,
      nav_show: false,
      detail: null,
      keywords: '',
      area_title: '地点',
      area: '全部',
      areas: [],
      page: 1,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      position_type: '',
      empty_msg: null,
      images: null,
      showPopover: false,
    }
  },
  mounted() {
    this.position_type = this.$route.query.position_type
    document.title = '中船航海人才招聘'
    setTimeout(() => {
      this.loadData()
    }, 1000)
  },
  methods: {
    loadData() {
      let that = this
      that.$api.employPositionList({
        page: that.page,
        keywords: that.keywords,
        area: that.area == '全部' ? '' : that.area,
        position_type: that.position_type
      }).then(res => {
        that.Util.wechatShare(res.data.share)
        if (that.page == 1) {
          that.list = []
          that.areas = res.data.areas
          that.images = res.data.images
        }
        that.list = that.list.concat(res.data.records.data)
        that.loading = false
        that.refreshing = false
        if (!res.data.records.next_page_url) {
          that.finished = true
        } else {
          that.page += 1
        }
        that.empty_msg = res.data.empty_msg
        that.page_show = true
      })
    },
    onRefresh() {
      this.finished = false
      this.loading = true
      this.page = 1
      this.loadData();
    },
    onAreaChange(e) {
      console.log('onAreaChange', e);
      this.area_title = e.text == '全部' ? '地点' : e.text
      this.area = e.text
      this.onRefresh()
    },
    onSearch() {
      console.log('onSearch');
      this.onRefresh()
    },
    onClear() {
      console.log('onClear');
      this.onRefresh()
    },
    onClickDetail(position_id) {
      let that = this
      that.popup_show = true
      that.$api.employPositionDetail({
        position_id: position_id,
      }).then(res => {
        that.detail = res.data.record
        that.post_router = res.data.path.post
      })
    },
    onNavClick(obj) {
      let that = this
      that.nav_show = false
      if (obj) {
        setTimeout(() => {
          if (obj.url) {
            window.location.href = obj.url
          } else if (obj.name) {
            that.$router.push(obj)
          }
        }, 100)
      }
    }
  }
}
</script>
<style scoped src="./employ.css"></style>
<style scoped src="./positionList.css"></style>
    